module.exports = __webpack_public_path__ + "media/images/emblems/Gossau_wappen_gross-6f20674514d83c5c5bfcf14ddf9c5653.png";